import { util as sdkUtil } from '../../util/sdkLoader';
import { axiosApi } from '../../util/axiosApi';
const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

export const getLatestListings = (data, isColumnLayout) => {
  const params = new URLSearchParams(data).toString();

  return axiosApi.get(`/latest-listings?${params}`)
    .then(res => {
      return sdk.listings
        .query({
          ids: res.data,
          include: ['author', 'images', 'author.profileImage', 'profileImage'],
          'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'description', 'createdAt'],
          'fields.user': [
            'profile.displayName',
            'profile.abbreviatedName',
            'profile.publicData',
            'profileImage',
            'profile.profileImage',
          ],

          'fields.image': ['variants.square-small', 'variants.landscape-crop-custom',],
          'imageVariant.landscape-crop-custom': sdkUtil.objectQueryString({
            w: 400,
            h: 400,
            fit: 'scale'
          })
        })
    })
    .then(res => {
      const listings = res.data.data;
      const images =
        res.data.included &&
        res.data.included.filter(i => {
          return i.type === 'image';
        });
      const users =
        res.data.included &&
        res.data.included.filter(i => {
          return i.type === 'user';
        });

      if (users && users.length > 0) {
        users.forEach(u => {
          const imageId = u.relationships.profileImage.data?.id.uuid;

          const luckyImage = images.find(i => {
            return i.id.uuid === imageId;
          });

          u.profileImage = luckyImage;
        });
      }

      if (listings && listings.length > 0) {
        listings.forEach(l => {
          const ownImages = l.relationships.images.data; //.data[0]?.id.uuid;
          const authorId = l.relationships.author.data?.id.uuid;

          const luckyImages = images.filter(i => {
            return ownImages.find(img => img?.id?.uuid === i?.id?.uuid); //i?.id.uuid === imageId;
          });

          const author = users.find(u => {
            return u?.id.uuid === authorId;
          });
          l.author = author;
          l.images = [...luckyImages];
        });
      }

      const listingsLeftToPush = 12 - listings.length;
      let finalListings = [...listings];

      for (let i = 1; i <= listingsLeftToPush; i++) {
        finalListings.push(listings[getRandomInt(listings.length - 1)]);
      }

      const finalListingsFiltered = finalListings.filter(l => l && l.attributes);
      return isColumnLayout ? listings : finalListingsFiltered;
    })
    .catch(e => console.log(e));
};
